module.exports = __webpack_public_path__ + "img/banner2.6dd99910.png";